
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentcolor","d":"M2.219 10.651c.345 0 .625-.28.625-.625v-.62c0-.689.56-1.25 1.25-1.25h3.281v1.875a.625.625 0 001.25 0V8.156h3.281c.69 0 1.25.561 1.25 1.25v.62a.625.625 0 101.25 0v-.62c0-1.378-1.121-2.5-2.5-2.5H8.625V4.063h1c.345 0 .625-.28.625-.625V.624A.625.625 0 009.625 0h-3.25a.625.625 0 00-.625.625v2.813c0 .345.28.624.625.624h1v2.844H4.094a2.503 2.503 0 00-2.5 2.5v.62c0 .346.28.625.625.625zM7 2.813V1.25h2v1.563H7zm8.375 9.125h-3.219a.625.625 0 00-.625.624v2.813c0 .345.28.625.625.625h3.219c.345 0 .625-.28.625-.625v-2.813a.624.624 0 00-.625-.624zm-.625 2.812h-1.969v-1.563h1.969v1.563zM3.844 11.938H.625a.625.625 0 00-.625.624v2.813c0 .345.28.625.625.625h3.219c.345 0 .625-.28.625-.625v-2.813a.624.624 0 00-.625-.624zm-.625 2.812H1.25v-1.563h1.969v1.563zm6.406-2.812h-3.25a.625.625 0 00-.625.624v2.813c0 .345.28.625.625.625h3.25c.345 0 .625-.28.625-.625v-2.813a.624.624 0 00-.625-.624zM9 14.75H7v-1.563h2v1.563z"}})])
          )
        }
      }
    